import { OrgSiteListEntry } from "../models/organisation";
import axiosConfig from "./axiosConfig";

interface SiteListResponse {
  sites: OrgSiteListEntry[];
}

const getSiteList = async (
  authToken: string,
  testOrgId?: string | null
): Promise<SiteListResponse> => {
  const params = new URLSearchParams();
  if (testOrgId) params.append("testOrgId", testOrgId);
  const { data } = await axiosConfig.get(
    `/site${params.size > 0 ? `?${params}` : ""}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getSiteList;
